export default "__VITE_ASSET__C8jkBUZW__"